import React, { useEffect, Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import './index.css';

// ── Chargement immédiat — page principale (toujours nécessaire) ──────────
import App from './App';
import Page404 from './components/Page404';
const PagePolitiqueConfidentialite = React.lazy(() => import('./components/PagePolitiqueConfidentialite'));

// ── Lazy loading — pages secondaires chargées uniquement à la demande ────
// Chaque page devient un chunk JS séparé, téléchargé uniquement quand
// l'utilisateur navigue vers cette route. Réduit le bundle initial de ~40%.
const PageFormulaireCommerce  = React.lazy(() => import('./components/PageFormulaireCommerce'));
const PageFormulaireEntreprise = React.lazy(() => import('./components/PageFormulaireEntreprise'));
const PageEspaceCommercant    = React.lazy(() => import('./components/PageEspaceCommercant'));
const PageCommerces           = React.lazy(() => import('./components/PageCommerces'));
const PageCGU                 = React.lazy(() => import('./components/PageCGU'));
const PageActualites          = React.lazy(() => import('./components/PageActualites'));

// ── Écran de chargement affiché pendant qu'un chunk se télécharge ────────
function PageLoader() {
  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100vh',
      background: '#fff',
      flexDirection: 'column',
      gap: 16,
    }}>
      <img
        src="/assets/icons/logo-variant.svg"
        alt="Welly"
        style={{ height: 48, opacity: 0.7, animation: 'pulse 1.5s ease-in-out infinite' }}
      />
      <style>{`
        @keyframes pulse {
          0%, 100% { opacity: 0.4; transform: scale(1); }
          50%       { opacity: 0.9; transform: scale(1.05); }
        }
      `}</style>
    </div>
  );
}

// ── Routes qui déclenchent un scroll en haut ─────────────────────────────
const SECONDARY_ROUTES = [
  '/politique-confidentialite',
  '/devenir-partenaire',
  '/demander-devis',
  '/espace-commercant',
  '/commerces',
  '/cgu',
  '/actualites',
];

function ScrollManager() {
  const { pathname } = useLocation();

  useEffect(() => {
    const isSecondary = SECONDARY_ROUTES.includes(pathname);
    const isHomePage  = pathname === '/';

    if (isSecondary) {
      window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
    } else if (isHomePage) {
      const saved = sessionStorage.getItem('homeScrollPosition');
      if (saved) {
        setTimeout(() => {
          window.scrollTo({ top: parseInt(saved, 10), left: 0, behavior: 'instant' });
        }, 50);
        sessionStorage.removeItem('homeScrollPosition');
      }
    }
  }, [pathname]);

  return null;
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <ScrollManager />
      <Suspense fallback={<PageLoader />}>
        <Routes>
          <Route path="/"                    element={<App />} />
          <Route path="/devenir-partenaire"  element={<PageFormulaireCommerce />} />
          <Route path="/demander-devis"      element={<PageFormulaireEntreprise />} />
          <Route path="/espace-commercant"   element={<PageEspaceCommercant />} />
          <Route path="/commerces"           element={<PageCommerces />} />
          <Route path="/cgu"                 element={<PageCGU />} />
          <Route path="/actualites"          element={<PageActualites />} />
          <Route path="/politique-confidentialite" element={<PagePolitiqueConfidentialite />} />
          <Route path="*" element={<Page404 />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  </React.StrictMode>
);
